import moment from "moment";
import _ from "lodash";
import $ from 'jquery';

import * as baseLib from './MercuryBaseLib';
import baseRule from './MercuryBaseRule';
import * as baseSkylab from './MercuryBaseSkylab';
import * as baseUtils from './MercuryBaseUtils';

window.API_HOST = baseLib.API_HOST;
window.jQuery = $;
window.$ = $;
window.mercury = {
  base: {
    lib: baseLib,
    rule: baseRule,
    skylab: baseSkylab,
    util: baseUtils
  }
}


const MercuryGlobal = {
  install(Vue, options) {

    Vue.prototype.mercury = window.mercury

    //권한 관련 글로벌 mixIn
    Vue.mixin({
      computed: {
        isMercury() {
          return this.hasAnyRole('SYSTEM_MANAGER')
        },
        currentUser() {
          return this.$store.getters['base/getUser']
        }
      },
      methods: {
        setOverlay: function(overlay){
          this.$store.dispatch('base/setOverlay', overlay);
        },
        hasAnyRoleM: function(roles) {
          if(this.isMercury){
            return this.hasAnyRole(roles)
          }
          return false;
        },
        hasAnyRole: function (roles) {
          if(typeof roles === 'string'){
            roles = [roles]
          }

          const rolesMap = this.$store.getters['base/getUser'].rolesMap;
          for(let i = 0, ic = roles.length; i < ic; i++){
            if(rolesMap[roles[i]]){
              return true
            }
          }

          return false;
        },
      },
    })


    Vue.prototype.moment = moment;
    Vue.prototype._ = _;
    Vue.prototype.xAjax = baseLib.xAjax;
    Vue.prototype.xAjaxJson = baseLib.xAjaxJson;
    Vue.prototype.xAjaxMultipart = baseLib.xAjaxMultipart;

    Vue.prototype.$settings = {
      requestMapping: baseLib.API_HOST,
      datatable: {
        rows2: "90px",
        rows5: "202px",
        rows6: "234px",
        rows10: "362px",
        rows15: "522px",
        rows20: "682px",
        rows25: "844px",
        rows30: "1006px",
        footer2: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [2, 10, 50]
        },
        footer5: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [5, 25, 100]
        },
        footer6: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [6, 25, 100]
        },
        footer10: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [10, 20, 50, 100]
        },
        footer15: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [15, 30, 100]
        },
        footer20: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [20, 40, 100]
        },
        footer25: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [25, 50, 100]
        },
        footer30: {
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions: [30, 60, 100]
        },
        getItemsPerPageOptions: ((min = 5, max = 100, step = 5,) => (Array(Math.floor((max - min) / step) + 1).fill(min).map(((x, i) => (x + i * step)),)))
      }
    }

    Vue.filter("comma", val =>{
      let str = String(val).split(".");
      str[0] = str[0].replace(/,/g,'')
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return str.join(".");

      // return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    })

    /*Vue.filter('comma', {
      // model -> view  formats the value when updating the input element.
        read: function(val) {
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        // view -> model    // formats the value when writing to the data.

        write: function(val, oldVal) {
            return String(val).replace(/,/g, "");
        }
    });*/

    Vue.component('mp-button', {
      template: `
            <v-tooltip top v-if="mode === 'search'">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn :color="color" v-bind="attrs" v-on="on" @click="clickEvent" class="ml-1 mp-button mp-button-search" :class="className" :aria-label="label"
                           :disabled="disabled" :loading="loading">
                        <v-icon>{{icon}}</v-icon>
                    </v-btn>
                </template>
                <span><slot>{{label}}</slot></span>
            </v-tooltip>
            <v-tooltip top v-else-if="mode === 'label'">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn :color="color" v-bind="attrs" v-on="on" @click="clickEvent" class="ml-1 mp-button mp-button-label" :class="className" outlined small text :aria-label="label"
                           :disabled="disabled" :loading="loading">
                        <v-icon>{{icon}} mdi-18px</v-icon>
                        {{label}}
                    </v-btn>
                </template>
                <span><slot>{{label}}</slot></span>
            </v-tooltip>
            <v-tooltip top v-else-if="mode === 'icon'">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon :color="color" v-bind="attrs" v-on="on" @click="clickEvent" class="ml-1 mp-button mp-button-icon" small :disabled="disabled" :class="className" :aria-label="label">{{!loading ? icon : 'mdi-cached mdi-spin'}} mdi-18px</v-icon>
                </template>
                <span><slot>{{label}}</slot></span>
            </v-tooltip>
            <v-btn v-else-if="mode === 'text'" :color="color" @click="clickEvent" class="ml-1 mp-button mp-button-text" outlined raised text :class="className" :disabled="disabled" :aria-label="label">
                <v-icon>{{!loading ? icon : 'mdi-cached mdi-spin'}} mdi-18px</v-icon>
                <slot>{{label}}</slot>
            </v-btn>
        `,
      props: {
        mode: {
          type: String,
          default: 'search'
        },
        disabled: {
          type: Boolean,
          default: false,
        },
        loading: {
          type: Boolean,
          default: false,
        },
        className: String,
        label: String,
        color: String,
        click: Function,
        icon: String
      },
      methods: {
        clickEvent() {
          this.$emit("click");
        }
      }
    });

    Vue.component('mp-search', {
      template: `
            <v-form class="search-form">
                <v-container :class="classes">
                    <v-row class="ubcs-search-div">
                        <slot></slot>
                    </v-row>
                    <slot name="extends"></slot>
                </v-container>
            </v-form>
        `,
      props: {
        classes: {
          type: Array,
          default: () => []
        }
      }
    });

    Vue.component('mp-date-range-picker', {
      template: `
            <div :class="classes">
                <v-md-date-range-picker
                        :label="label"
                        :max-year="maxYear"
                        :min-year="minYear"
                        show-year-select
                        v-model="dModel"
                        :presets="presets"
                        :editable="editable"
                        :multiple="multiple"
                        :type="type"
                        :language="($i18n && $i18n.locale)? $i18n.locale : 'en'"
                        show-total-range-label
                        :custom-locale="locale"
                >
                    <template v-slot:picker-input="{label, value}">
                        <slot name="input" v-bind:label="label" v-bind:value="value">
                            <template v-if="shape === 'underline'">
                                <v-text-field :label="label" v-model="value"></v-text-field>
                            </template>
                            <template v-else>
                                <v-text-field :label="label" v-model="value" outlined dense hide-details></v-text-field>
                            </template>
                        </slot>
                    </template>
                  <template #picker-input-start="{value, changeHandler, editable}">
                    <slot name="input-start" v-bind:label="labelStart" v-bind:value="value" v-bind:changeHandler="changeHandler" v-bind:editable="editable">
                      <v-text-field v-if="shape === 'underline'" :label="labelStart" v-model="value" @input="changeHandler" :readonly="!editable" :rules="[rules.date]"></v-text-field>
                      <v-text-field v-else v-model="value" :label="labelStart" @input="changeHandler" :readonly="!editable" outlined dense hide-details :rules="[rules.date]"></v-text-field>
                    </slot>
                  </template>
                  <template #picker-input-end="{value, changeHandler, editable}">
                    <slot name="input-end" v-bind:label="labelEnd" v-bind:value="value" v-bind:changeHandler="changeHandler" v-bind:editable="editable">
                      <v-text-field v-if="shape === 'underline'" :label="labelEnd" v-model="value" @input="changeHandler" :readonly="!editable" :rules="[rules.date]"></v-text-field>
                      <v-text-field v-else v-model="value" :label="labelEnd" @input="changeHandler" :readonly="!editable" outlined dense hide-details :rules="[rules.date]"></v-text-field>
                    </slot>
                  </template>
                </v-md-date-range-picker>
            </div>
        `,

      props: {
        multiple: {
          type: Boolean,
          default: false
        },
        editable: {
          type: Boolean,
          default: false
        },
        classes: {
          type: Array,
          default: () => []
        },
        type: {
          type: String,
          default: "calendar"
        },
        format: {
          type: String,
          default: "date"
        },
        start: {
          type: String    //2020-01-01
        },
        end: {
          type: String    //2020-01-02
        },
        minYear: {
          type: String,
          default: '2010'
        },
        maxYear: {
          type: String,
          default: '2030'
        },
        label: {
          type: String,
          default: "기간"
        },
        'labelStart': {
          type: String,
          default: '시작일'
        },
        'labelEnd': {
          type: String,
          default: '종료일'
        },
        shape: {
          type: String,
          default: 'outlined'
        },
        presets: {
          type: Object,
          default: function () {
            return {
              calendar: [
                {
                  label: this.$t('calendar.today'),
                  range: mercury.base.util.getDateRange(0, 0),
                },
                {
                  label: this.$t('calendar.yesterday'),
                  range: mercury.base.util.getDateRange(1, 1),
                },
                {
                  label: this.$t('calendar.7daysAgo'),
                  range: mercury.base.util.getDateRange(6, 0),
                },
                {
                  label: this.$t('calendar.30daysAgo'),
                  range: mercury.base.util.getDateRange(29, 0),
                },
                {
                  label: this.$t('calendar.thisMonth'),
                  //range: mercury.base.util.getDateRange(0, 0, 'month'),
                  range: [
                    moment().set('date', 1),
                    moment()
                  ]
                },
                {
                  label: this.$t('calendar.1monthAgo'),
                  range: mercury.base.util.getDateRange(1, 1, 'month'),
                }
              ],
              month: [
                {
                  label: '이번달',
                  range: mercury.base.util.getDateRange(0, 0, 'month'),
                },
                {
                  label: '지난달',
                  range: mercury.base.util.getDateRange(1, 1, 'month'),
                },
                {
                  label: '올해',
                  range: mercury.base.util.getDateRange(0, 0, 'year'),
                },
                {
                  label: '작년',
                  range: mercury.base.util.getDateRange(1, 1, 'year'),
                }
              ]
            };
          }
        }
      },
      data: function () {
        return {
          dModel: {
            start: null,
            end: null
          },
          locale: {
            customRangeLabel: '직접선택',
            totalRangeLabel: '전체',
            format: 'YYYY-MM-DD'
          },
          rules: {
            dateRange: value => value.replace(/[^0-9]/g, '').length === 16 || 'Invalid dateRange.',
            date: value => value.replace(/[^0-9]/g, '').length === 8 || 'Invalid date.'
          }
        }
      },
      created() {
        const start = this.start || moment({year: this.minYear}).startOf('year').format(this.locale.format)
        const end = this.end || moment({year: this.maxYear}).endOf('year').format(this.locale.format)

        Object.assign(this.dModel, {
          start: start,
          end: end
        });

        if(this.format === 'datetime'){
          this.$emit("update:start", moment(start, this.locale.format).format('YYYY-MM-DD 00:00:00'));
          this.$emit("update:end", moment(end,this.locale.format).format('YYYY-MM-DD 23:59:59'));
        }
      },
      watch: {
        "dModel": {
          handler: function (data) {
            if(this.format === 'datetime'){
              this.$emit("update:start", moment(data.start).format('YYYY-MM-DD 00:00:00'));
              this.$emit("update:end", moment(data.end).format('YYYY-MM-DD 23:59:59'));
            }else{
              this.$emit("update:start", moment(data.start).format(this.locale.format));
              this.$emit("update:end", moment(data.end).format(this.locale.format));
            }
          },
          deep: true
        },
        "start":{
          handler: function (date) {
            this.$nextTick(()=>{
              this.dModel.start = moment(date, this.locale.format).toDate();
              if(this.format === 'datetime'){
                this.$emit("update:start", moment(date).format('YYYY-MM-DD 00:00:00'));
              }else{
                this.$emit("update:start", date);
              }
            });
          }
        },
        "end":{
          handler: function (date) {
            this.$nextTick(()=>{
              this.dModel.end = moment(date, this.locale.format).toDate();
              if(this.format === 'datetime'){
                this.$emit("update:end", moment(date).format('YYYY-MM-DD 23:59:59'));
              }else{
                this.$emit("update:end", date);
              }
            });
          }
        }
      }
    });

    Vue.component('mp-date-picker', {
      template: `
            <div>
                <v-menu max-width="290px" min-width="auto" transition="scale-transition" offset-y ref="menu" v-model="menu"
                    :close-on-content-click="!confirm"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <template v-if="shape === 'underline'">
                            <v-text-field v-model.sync="text" :label="label" :readonly="readonly" v-bind="attrs" v-on="on" @change="apply"></v-text-field>
                        </template>
                        <template v-else>
                            <v-text-field v-model.sync="text" :label="label" :readonly="readonly" v-bind="attrs" v-on="on" @change="apply" outlined dense hide-details></v-text-field>
                        </template>
                    </template>
                    <template v-if="type==='range'">
                        <v-date-picker v-model.sync="dModel" :locale="locale" no-title scrollable range>
                            <template v-if="confirm">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                                <v-btn text color="primary" @click="apply(dModel)">OK</v-btn>
                            </template>
                        </v-date-picker>
                    </template>
                    <template v-else>
                        <v-date-picker v-model.sync="dModel" :locale="locale" no-title scrollable :type="type">
                            <template v-if="confirm">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                                <v-btn text color="primary" @click="apply(dModel)">OK</v-btn>
                            </template>
                        </v-date-picker>
                    </template>
                </v-menu>
            </div>
        `,
      props: {
        label: String,
        locale: {
          type: String,
          default: 'ko-kr'
        },
        type: {
          type: String,
          default: 'date'
        },
        value: {
          type: String,
          default: function(){
            if(this.type === 'date'){
              return moment().format('YYYY-MM-DD');
            }else if(this.type === 'month'){
              return moment().format('YYYY-MM');
            }else if(this.type === 'range'){
              return moment().format('YYYY-MM-DD') +' ~ '+ moment().format('YYYY-MM-DD');
            }
          }
        },
        readonly: {
          type: Boolean,
          default: false
        },
        confirm: {
          type: Boolean,
          default: true
        },
        shape: {
          type: String,
          default: 'outlined'
        },
      },
      data: function () {
        return {
          menu: false,
          dModel: undefined,
          text: undefined
        }
      },
      mounted() {
        this.reset();
      },
      watch: {
        "dModel": {
          handler: function (data) {
            if(!this.confirm){
              this.apply(data);
            }
          },
          deep: true
        }
      },
      methods: {
        reset(){
          this.text = this.value;
          if(this.type === 'range'){
            this.dModel = this.value.split(' ~ ');//array 필요
          }else{
            this.dModel = this.value;
          }
        },
        cancel(){
          this.reset();
          this.menu = false;
        },
        apply(data){
          if(this.type === 'range'){
            if(typeof data === 'string'){
              data = data.split(' ~ ');
            }

            this.dModel = data.sort();//반대 클릭시 시작 종료 정렬
            this.text = this.dModel.join(' ~ ');
          }else {
            this.dModel = data;
            this.text = data;
          }

          if(!this.validateDate(data)){
            return this.reset();
          }

          this.$emit("input", this.text); //value update
          this.menu = false;
        },
        validateDate(date){
          if(typeof date === 'string'){
            return moment(date).isValid();
          }else{//array range
            const dataLen = date.length;
            if(dataLen !== 2){
              return false;
            }

            for(let i = 0; i < dataLen; i++){
              if(!moment(date[i]).isValid()){
                return false;
              }
            }

            return true;
          }
        }
      }
    })



    Vue.component('mp-view', {
      template: `
            <div v-if="dView.mode === 'sheet'">
                <v-sheet v-if="dView.show">
                    <slot name="head" v-bind:edit="dView.edit"></slot>
                    <slot name="body" v-bind:edit="dView.edit"></slot>
                    <v-card-actions>
                        <slot name="control.prepend" v-bind:edit="dView.edit"></slot>
                        <v-spacer></v-spacer>
                        <slot name="control" v-bind:edit="dView.edit"></slot>
                    </v-card-actions>
                </v-sheet>
            </div>
            <div v-else-if="dView.mode === 'dialog'">
                <v-dialog v-model="dView.show" :max-width="dView.width" scrollable @keydown.esc="closeDialog()"
                          @click:outside="closeDialog()" overlay-color="#fff">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{dView.title}}</span>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="closeDialog()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <slot name="head" v-bind:edit="dView.edit"></slot>
                            <slot name="body" v-bind:edit="dView.edit"></slot>
                        </v-card-text>
                        <v-card-actions>
                            <slot name="control.prepend" v-bind:edit="dView.edit"></slot>
                            <v-spacer></v-spacer>
                            <slot name="control" v-bind:edit="dView.edit"></slot>
                            <slot name="close" v-bind:edit="dView.edit">
                                <v-btn color="secondary" text @click="closeDialog()" outlined raised>
                                    <v-icon>mdi-close mdi-18px</v-icon>
                                    닫기
                                </v-btn>
                            </slot>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        `,
      props: {
        view: Object
      },
      data: function () {
        return {
          dView: Object.assign({
            mode: 'sheet',  //  sheet || dialog
            show: false,
            edit: false,
            width: '600px',
            title: '제목'
          }, this.view)
        }
      },
      watch: {
        "view": {
          handler: function (view) {
            Object.assign(this.dView, view);
          },
          deep: true
        }
      },
      methods: {
        closeDialog() {
          this.dView.show = false;
          this.$emit("update:view", this.dView);
        }
      }
    });

    Vue.component('mp-dialog', {
      template:`
            <v-dialog :retain-focus="false" :fullscreen="fullscreen" v-model="dialog.visible" :width="dialog.width||1024" scrollable :persistent="persistent" overlay-color="#fff"
                  @keydown.esc="onClickEsc"
                  @click:outside="onClickOutside">
                <v-card>
                    <v-card-title class="headline lighten-2">{{ dialog.title }}<v-spacer></v-spacer>
                        <v-btn icon @click="dialog.close()"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text v-if="dialog.visible" >
                        <component ref="dialog-component" :is="dialog.component" v-bind.sync="dialog.props" :dialog="dialog" @close="dialog.close()" @setVisibleActions="setVisibleActions"></component>
                    </v-card-text>
                    <v-card-actions v-if="visibleActions">
                        <template v-if="dialog.actions && dialog.actions.left">
                            <v-btn v-for="(item, index) in dialog.actions.left" :key="item.name+index" :color="item.color" text @click="invokeComponentMethod(item)" outlined raised>{{item.name}}</v-btn>
                        </template>
                        <v-spacer></v-spacer>
                        <template v-if="dialog.actions && dialog.actions.right">
                            <v-btn v-for="(item, index) in dialog.actions.right" :key="item.name+index" :color="item.color" text @click="invokeComponentMethod(item)" outlined raised>{{item.name}}</v-btn>
                        </template>
                        <v-btn color="grey" text @click="dialog.close()" outlined raised>Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        `,
      data: () => ({
        visibleActions: true
      }),
      props: {
        fullscreen: {
          type: Boolean,
          default: false
        },
        persistent: {
          type: Boolean,
          default: true
        },
        dialog: Object
        /*
        {
            title: '플랫폼 관리',
            width: 1024
            visible: false,
            reload: true,
            component: MpAdvertiserPlatform,
            props: {advertiser: {}},
            close: () => {this.dialog.platform.visible = false;},
            actions:{
                left:[
                    {
                        name:'복사',
                        color: 'green',
                        method: 'callInner'
                    }
                ],
                right:[
                    {
                        name:'저장',
                        color: 'danger',
                        method: 'callInner'
                    }
                ]
            }
        }
        */
      },
      methods: {
        setVisibleActions(bool = true) {
          this.visibleActions = bool;
        },
        onClickOutside() {
          if(!this.persistent){
            this.dialog.close()
          }
        },
        onClickEsc(){
          this.dialog.close()
        },
        invokeComponentMethod(btn){
          if (typeof this.$refs['dialog-component'][btn.method] === 'function'){
            this.$refs['dialog-component'][btn.method](this.dialog)
          }else{
            let msg = this.dialog.component.name+' component 의 ' +btn.method+' 가 정의되지 않았거나 Function 이 아닙니다.';
            this.mercury.base.lib.notify({message: msg, type:'error'})
          }
        }
      }
    });

    Vue.component('mp-boolean-yn', {
      template: `
            <span v-if="mode === 'chip'">
                <v-chip color="green" v-if="value === 'Y'" small>사용</v-chip>
                <v-chip color="gray" v-else small>미사용</v-chip>
            </span>
            <span v-else-if="mode === 'boolean'">
                <v-chip color="green" v-if="value === 'true'" small>예</v-chip>
                <v-chip color="gray" v-else small>아니오</v-chip>
            </span>
            <span v-else>
                <span v-if="value === 'Y'">Y</span>
                <span v-else>X</span>
            </span>
        `,
      props: {
        value: String,
        mode: {
          type: String,
          default: 'chip'
        }
      }
    });

    Vue.component('mp-number-field', {
      template: `
            <v-text-field :label="label" :value="value | comma" @input="val => this.$emit('update:value',String(val).replace(/,/g,''))" :rules="mercury.base.rule.required" class="mp-number-field"></v-text-field>
        `,
      props: {
        label: String,
        value: String|Number,
      }
    });

    //form 내에 인풋이 한개 밖에 없는 경우 enter를 누르면 자동 form submit이 발생하는 걸 막기 위해 빈 인풋을 추가
    Vue.component('mp-prevent-submit-input', {
      template: `<input type="text" style="position:absolute;width:0 !important;height:0 !important;line-height: 0 !important;"/>`,
    });


    Vue.component('mp-js-tree', {
      template: `
            <div :ref="refName" class="js-tree-wrapper"></div>
        `,
      props: {
        url: String,
        refName: {
          type: String,
          default: 'js-tree'
        },
        changed: Function,
        created: Function,
        renamed: Function,
        deleted: Function,
        moved: Function,
        multiple: {
          type: Boolean,
          default: false
        },
        dnd: {
          type: Boolean,
          default: false
        },
        state: {
          type: Boolean,
          default: false
        },
        checkCallback: {
          type: Function,
          default: function (operation, node, node_parent, node_position, more){
            return true;
          }
        },
        searchCallback: {
          type: Function,
          default: function (str, node){

          }
        },
        types: {
          type: Object,
          default: function(){
            return {
              'default': {
                'icon': 'mdi mdi-folder text-primary'
              },
              'folder': {
                'icon': 'mdi mdi-folder text-primary'
              },
              'file': {
                'icon': 'mdi mdi-file  text-primary'
              }
            }
          }
        }
      },
      data: function () {
        return {
          instance: undefined
        };
      },
      created() {

      },
      async mounted() {
        await this.fetchData();
      },
      computed: {},
      watch: {},
      methods: {
        async fetchData() {
          const options = {
            multiple: this.multiple,
            dnd: this.dnd,
            state: this.state,
            checkCallback: this.checkCallback,
            searchCallback: this.searchCallback,
            types: this.types
          };

          const plugins = ['themes', 'json_data', 'ui', 'crrm', 'types', 'search'/*, "wholerow"*//*, "contextmenu"*/];
          if (options['dnd']) {
            plugins.push('dnd');
          }
          if (options['state']) {
            plugins.push('state');
          }


          const _this = this;

          const treeData = await this.xAjax({
            url: this.url
          });

          const jsTreeOptions = {
            'plugins': plugins,
            'themes': {
              'responsive': false
            },
            core: {
              multiple: options.multiple,
              data: treeData,
              check_callback: function(operation, node, node_parent, node_position, more){
                //return _this.$emit('check-callback', operation, node, node_parent, node_position, more, _this.instance);
              }
            },
            'state': {
              'key': 'ubicus-base-tree-' + this.refName
            },
            'types': options.types,
            search: {
              case_insensitive: false,
              show_only_matches: true,
              show_only_matches_children: false,
              search_callback: function (str, node) {
                let keyword = str.trim();
                if (keyword === '') {
                  return true;
                }

                return node.text.toLowerCase().includes(keyword.toLowerCase());
              }
            }
          };

          const $refTree = $(this.$refs[this.refName]);
          $refTree.jstree(jsTreeOptions).on('changed.jstree', function (e, data) {
            _this.$emit('changed', e, data, _this.instance);
          }).on('create_node.jstree', function (e, data) {
            _this.$emit('created', e, data, _this.instance);
          }).on('rename_node.jstree', function (e, data) {
            _this.$emit('renamed', e, data, _this.instance);
          }).on('delete_node.jstree', function (e, data) {
            _this.$emit('deleted', e, data, _this.instance);
          }).on('move_node.jstree', function (e, data) {
            _this.$emit('moved', e, data, _this.instance);
          });

          this.instance = $refTree.jstree(true);
        },
        async refresh(nodeId) {
          if (nodeId !== undefined) {
            this.instance.refresh_node(nodeId);
          } else {
            this.instance.settings.core.data = await this.xAjax({
              url: this.url
            });
            this.instance.refresh();
          }
        },
        search(searchText) {
          this.instance.search(`${searchText}`);
        },
        showAll() {
          this.instance.show_all();
        },
        renameNode(node, text) {
          this.instance.rename_node(node, text);
        },
        getInstance() {
          return this.instance;
        },
        getPath(node) {
          const nodePath = '<i class="text-primary">' + node.text + '</i>';
          if (node.parent === '#') {
            return nodePath;
          } else {
            const prePath = this.instance.get_path(node.parent, ' > ');
            return '<i>' + prePath + '</i>' + '<i class="text-danger"> > </i>' + nodePath;
          }
        },
        deselectAll() {
          this.instance.deselect_all();
        },
        selectNode(nodeId) {
          this.instance.deselect_all();
          this.instance.select_node(nodeId);
        },
        getSelectedNode(isFull) {//boolean
          return this.instance.get_selected(isFull);
        },
        getNode(nodeId) {
          return this.instance.get_node(nodeId);
        },
        getTopNode(node) {
          if (typeof node === 'string') {//id
            node = this.instance.get_node(node);
          }

          let parent = node;
          let i = 0;
          while (parent.parent !== '#') {
            parent = this.instance.get_node(parent.parent);
            i++;

            if (i > 10) {
              console.log('loop count over ' + i);
              break;
            }
          }
          return parent;
        },
        expandAll() {
          this.instance.open_all();
        },
        collapseAll() {
          this.instance.close_all();
        }
      }
    });
  }
}

export default MercuryGlobal;
